<app-layout>
  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Cariler</h3>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-primary mr-3" (click)="netsisCariAktar(true)">Netsis'ten Getir</div>
            <div class="btn btn-sm btn-pill btn-success" (click)="new()">Yeni Cari</div>
          </div>
        </div>
        <div class="card-body p-0" *ngIf="iceriAktarSource && iceriAktarSource.length>0">
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
              <tr>
                <th class="w-1">Id</th>
                <th>CariKodu</th>
                <th>FirmaUnvani</th>
                <th>YetkiliKisi</th>
                <th>MailAdresi</th>
                <th>Sehir</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let c of iceriAktarSource;">
                <td><span class="text-muted">{{c.id}}</span></td>
                <td>{{c.cariKodu}}</td>
                <td>{{c.firmaUnvani}}</td>
                <td>{{c.yetkiliKisi}}</td>
                <td>{{c.mailAdresi}}</td>
                <td>{{c.sehir?.aciklama}}</td>
              </tr>
              </tbody>
            </table>
            <div class="btn btn-success m-3" (click)="netsisCariAktar(false)">Aktar</div>
          </div>
        </div>
        <div class="card-body border-bottom py-3">
          <div class="d-flex">
            <div class="mr-auto text-muted">
              Arama yap:
              <div class="ml-2 d-inline-block">
                <div class="input-icon mb-3">
                 <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="cariAraLoading">
                                <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                              </span>
                  <input name="kalemAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                         [(ngModel)]="cariAraText" placeholder="Yazın ve Enter'a basın"
                         (keyup.enter)="cariAraInputChange()">
                </div>
              </div>
            </div>
            <div class="text-muted">
              Gösterilen
              <div class="mx-2 d-inline-block">
                <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCount"
                        (change)="cariAraInputChange()">
                  <option *ngFor="let p of showSearchResultCountModel" [ngValue]="p">{{p}}</option>
                </select>
              </div>
              sonuç sayısı
            </div>
          </div>
        </div>
        <div class="table-responsive" *ngIf="source && source.results">
          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
            <tr>
              <th class="w-1">Id</th>
              <th>CariKodu</th>
              <th>FirmaUnvani</th>
              <th>YetkiliKisi</th>
              <th>MailAdresi</th>
              <th>Sehir</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let c of source.results;">
              <td><span class="text-muted">{{c.id}}</span></td>
              <td>{{c.cariKodu}}</td>
              <td>{{c.firmaUnvani}}</td>
              <td>{{c.yetkiliKisi}}</td>
              <td>{{c.mailAdresi}}</td>
              <td>{{c.sehir?.aciklama}}</td>
              <td class="text-right">
                <div *ngIf="!c.isAktarildi" class="btn btn-sm btn-warning" (click)="netsiseAktar(c)">Netsis'e Aktar</div>
                <div class="btn btn-sm btn-success ml-2" (click)="incele(c)">İncele</div>
                <div class="btn btn-sm btn-danger ml-2" (click)="sil(c)">Sil</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer d-flex align-items-center" *ngIf="source">
          <p class="m-0 text-muted"><span>{{source.rowCount}}
            sonuçtan {{source.firstRowOnPage}}</span>-<span>{{source.lastRowOnPage}}</span> arası sonuçlar
          </p>
          <ul class="pagination m-0 ml-auto">
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage === 1}">
              <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResults()">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="15 6 9 12 15 18"></polyline>
                </svg>
                önceki
              </div>
            </li>
            <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPage === source.pageCount}">
              <div class="page-link" (click)="showNextPageSearchResults()">
                sonraki
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                     stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <polyline points="9 6 15 12 9 18"></polyline>
                </svg>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</app-layout>
